const state = {
	guestCart: [],
	userCart: []
}

export default state